import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { RenderDatePicker, RenderTextArea } from '../../../component/formInput';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';

const validate = values => {
  const errors = {};
  if(!values.new_expired) {
    errors.new_expired = 'Ngày hết hạn không được bỏ trống';
  };
  return errors;
}

class ExpiredModifyModal extends React.Component {

  constructor(props) {
    super(props);
  }

  handleOnHide = () => {
    const { onHide, destroy } = this.props;
    destroy();
    onHide();
  }

  submit = (values) => {
    const { userProduct } = this.props;
    const self = this;
    const old_expired_time = moment(userProduct.expired).format("HH:mm:ss");
    return axios({
      method: 'post',
      url: window.api_url + '/admin/api/service/expired/modify',
      data: {
        user_product_id: userProduct.id,
        new_expired: moment(values.new_expired).format(`YYYY-MM-DD ${old_expired_time}`),
        reason: values.reason
      },
      withCredentials: true
    }).then(function (response) {
      if (!response.data.isError) {
        toast.success("Thay đổi ngày hết hạn thành công.")
        self.handleOnHide();
      } else {
        toast.error(response.data.error)
      }
    })
  }

  render() {
    const { title, submitting, handleSubmit, userProduct } = this.props;
    const modalConfig = { backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, submitting: this.props.submitting };
    return <div style={{ width: '30%' }}>
      <ToastContainer />
      <Modal {...modalConfig} aria-labelledby="contained-modal-title-lg">
        <Modal.Header className="bg-warning" closeButton>
          <Modal.Title id="contained-modal-title-sm">{title}</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(this.submit)}>
          <Modal.Body>
            <div style={{paddingTop:20}}> 
              <p> Domain/Code: <strong>{userProduct.product && userProduct.domain}</strong></p>
              <p> IP: <strong>{userProduct.product && userProduct.ip_address}</strong></p>
              <p> Dịch Vụ: <strong>{userProduct.product && userProduct.product.code}</strong></p>
              <p> Ngày hết hạn cũ: <strong>{moment(userProduct.expired).format("DD/MM/YYYY HH:mm:ss")}</strong></p>
              <Field name="new_expired" dateFormat="dd/MM/yyyy" placeholder="Chọn ngày hết hạn." component={RenderDatePicker}></Field>
              <Field name="reason" placeholder="Vui lòng điền lý do thay đổi ngày hết hạn..." component={RenderTextArea}></Field>
            </div>  
          </Modal.Body>
          <Modal.Footer>
            <div className="text-right">
              <a style={{marginRight: 10}} className="btn" onClick={() => this.handleOnHide()}>Đóng</a>
              <button type="submit" className="btn bg-warning" disabled={submitting}>Cập nhật</button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  }
}
const mapState = state => ({

});

const mapDispatch = dispatch => ({
    
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'ExpiredModifyModal',
    destroyOnUnmount: true,
    enableReinitialize: true,
    validate
  })(withRouter(ExpiredModifyModal))));
